import React, { useContext } from 'react';
import { AuthContext } from '../../hooks/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import PrivateLayout from "../Layout/PrivateLayout"

const ProtectedRoute = () => {
  const { isLoggedIn } = useContext(AuthContext);
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return (
    <PrivateLayout>
      <Outlet />
    </PrivateLayout>
  );
};

export default ProtectedRoute;